import { forwardRef } from 'react';
import {
  styled,
  Box,
  TextField,
  Button,
  textFieldClasses,
  inputBaseClasses,
  buttonClasses,
} from '@mui/material';
import { LoadingButtonProps, LoadingButton } from '@mui/lab';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

export const DashboardVariantV2GiverContentContainer = styled(Box)(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: 1,
    overflow: 'hidden',
  }),
);

export const DashboardVariantV2GiverContentTabContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const DashboardVariantV2GiverContentActionsContainer = styled(Box)(
  ({ theme }) => ({
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    alignItems: 'center',

    '&:first-of-type': {
      paddingTop: theme.spacing(2),
    },
  }),
);

export const DashboardVariantV2GiverContentActionsFieldWithButtonGroup = styled(
  'div',
)(({ theme }) => ({
  display: 'inline-flex',
  borderRadius: theme.shape.borderRadius,
  width: '100%',

  [`& .${textFieldClasses.root} .${inputBaseClasses.root}`]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRightColor: 'transparent',
  },

  [`& .${buttonClasses.root}`]: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    marginLeft: -1,
  },
}));

export const DashboardVariantV2GiverContentActionsTextField = styled(TextField)(
  {
    minWidth: 400,
    flexShrink: 1,

    [`& .${inputBaseClasses.root}`]: {
      height: 41,
    },
  },
);

export const DashboardVariantV2GiverContentActionsButton = styled(Button)({
  height: 41,
});

export const DashboardVariantV2GiverContentActionsLoadingButton = styled(
  LoadingButton,
)({
  height: 41,
});

export const DashboardVariantV2GiverContentActionsIconButton = styled(
  forwardRef<
    HTMLButtonElement,
    LoadingButtonProps & { withEnabledPulse?: boolean }
  >(function DashboardVariantV2GiverContentActionsIconButton(inProps, ref) {
    const { withEnabledPulse, disabled, loading, className, ...restProps } =
      inProps;

    return (
      <LoadingButton
        {...restProps}
        ref={ref}
        disabled={disabled}
        loading={loading}
        className={classNames(className, {
          pulse: withEnabledPulse && !disabled && !loading,
        })}
      />
    );
  }),
)(({ theme }) => ({
  height: 41,
  minWidth: 41,
  padding: theme.spacing(0, 1.5),

  [`& .${buttonClasses.startIcon}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${buttonClasses.endIcon}`]: {
    marginLeft: theme.spacing(2),
  },

  [`&.${buttonClasses.disabled}`]: {
    opacity: 0.5,
  },
}));

export const DashboardVariantV2GiverContentActionsIconButtonIcon = styled(
  FontAwesomeIcon,
)(({ theme }) => ({
  width: 20,
  height: 20,
  fontSize: theme.typography.pxToRem(20),
}));

export const DashboardVariantV2GiverContentActionsIconButtonImg = styled('img')(
  {
    height: 20,
    objectFit: 'contain',
  },
);

export const DashboardVariantV2GiverContentWrapper = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  flex: 1,
  minHeight: 740,
  maxHeight: 740,
}));

export const DashboardVariantV2GiverContentDataTableContainer = styled('div')({
  height: '100%',
  width: 'calc(100vw - 38px)',
  overflowY: 'auto',

  '& .data-table-container': {
    display: 'flex',
    flexDirection: 'column',

    '& ._loading_overlay_wrapper': {
      height: 'auto',
      flex: 1,
    },
  },
});
